import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { data } from '../../data/universities';
import { converter } from '../../GraphQL/query/University.query';

import UniversityList from './UniversityList';

class UniversityListGQL extends Component {
  render() {
    return <UniversityList data={data.universities.map(converter)} {...this.props} />;
  }
}

UniversityListGQL.propTypes = {
  eduTag: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default UniversityListGQL;
